const i18n = require('riot-i18n');

module.exports = function(timestamp) {
    var dateValue = new Date(timestamp);
    var serverDate = new Date();

    var timeInHours = Math.floor(Math.abs(serverDate - dateValue) / 36e5);
    var timeInMinutes = Math.floor(Math.abs(serverDate - dateValue) / 6e4);

    if (timeInHours > 23 && timeInHours < 48) {
        return i18n.localise(`Yesterday`);
    } else if (timeInHours >= 48 && timeInHours < 168) {
        return `${(timeInHours / 24).toFixed(0)} ${i18n.localise('days ago')}`;
    } else {
        return timeInHours > 0 ?
            `${timeInHours} ${i18n.localise(`hour${(timeInHours === 1 ? '' : 's')} ago`)}`
            : timeInMinutes > 0 ?
                `${timeInMinutes} ${i18n.localise(`minute${(timeInMinutes === 1 ? '' : 's')} ago`)}`
                    : i18n.localise(`Just now`);
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/vendor/timeago.js
 **/